import { getEddyProject } from 'redux/middleware/api/eddy-service';
import { ThunkAction } from 'redux/types';
import reduxPoll, { cancelReduxPoll } from 'utils/redux-poll';
import { Type } from './action-types';
import { EDDY_PROJECT_POLL_ID } from './constants';

export const waitForEddyProject = (
  projectCuid: string,
): ThunkAction<Promise<void>> => async dispatch => {
  dispatch({
    type: Type.EDDY_PROJECT_POLL_REQUEST,
  });

  try {
    await reduxPoll(
      dispatch,
      async () => {
        const { response } = await dispatch(getEddyProject(projectCuid));

        if (response.status === 'processing' || response.status === 'queued') {
          dispatch({
            type: Type.EDDY_PROJECT_POLL_UPDATE,
            payload: {
              eddyProject: response,
            },
          });
        }

        if (response.status === 'completed') {
          dispatch({
            type: Type.EDDY_PROJECT_POLL_SUCCESS,
            payload: {
              eddyProject: response,
            },
          });
        }

        if (response.status === 'error') {
          dispatch({
            type: Type.EDDY_PROJECT_POLL_FAILURE,
          });
        }

        return response;
      },
      {
        id: EDDY_PROJECT_POLL_ID,
        intervalMillis: 2500,
        maxAttempts: 1500,
        retryAttempts: 3,
        shouldContinue: (error, value) => {
          if (
            error ||
            value.status === 'error' ||
            value.status === 'completed'
          ) {
            return false;
          }

          return true;
        },
      },
    );
  } catch (error) {
    dispatch({
      type: Type.EDDY_PROJECT_POLL_FAILURE,
    });

    throw error;
  }
};

export const cancelWaitForEddyProject = (): ThunkAction<void> => dispatch => {
  dispatch({
    type: Type.EDDY_PROJECT_POLL_CANCEL,
  });

  cancelReduxPoll(dispatch, EDDY_PROJECT_POLL_ID);
};

export const clearEddyProject = () => {
  return { type: Type.EDDY_PROJECT_CLEAR };
};
